import type { OfficePresenceUser } from '@contexts/OfficePresenceContext'

/**
 * 在線名單一人一筆。
 *
 * 伺服器是每條連線各一筆，同一個人多開分頁、手機與電腦同時開著時會有好幾筆。
 * 有一筆在辦公室就用那筆（名單才會把他放在「正在辦公室」），其餘保留第一次出現的順序。
 */
export function dedupePresenceByUser(list: OfficePresenceUser[]): OfficePresenceUser[] {
  const byUser = new Map<string, OfficePresenceUser>()
  for (const p of list) {
    const kept = byUser.get(p.userId)
    if (!kept || (kept.location !== 'office' && p.location === 'office')) byUser.set(p.userId, p)
  }
  return Array.from(byUser.values())
}
